import { languageKey } from "./getLanguage";

export const setLanguage = (language: string) => {
  return window.localStorage.setItem(languageKey, language);
};